export enum SpaSettingsLabels {
    RFIDConnected = "RFIDConnected",
    SBConnected = "SBConnected",
    YOCFWVer = "YOCFWVer",
    LPCFWVer = "LPCFWVer",
    SBFWVer = "SBFWVer",
    SPASN = "SPASN",
    TAG1 = "TAG1",
    TAG2 = "TAG2",
    setTSP = "setTSP",
    setFF = "setFF",
    setFD = "setFD",
    setOnHr = "setOnHr",
    setOnCy = "setOnCy",
    setOzHr = "setOzHr",
    setOzCy = "setOzCy",
    cfgToff = "cfgToff",
    FS = "FS",
    setPT = "setPT",
    sendflags = "sendflags",
    cfgP1 = "cfgP1",
    cfgP2 = "cfgP2",
    cfgP3 = "cfgP3",
    cfgP4 = "cfgP4",
    cfgP5 = "cfgP5",
    cfgB1 = "cfgB1",
    cfgB2 = "cfgB2",
    cfgLi = "cfgLi",
    cfgSt = "cfgSt",
    cfgH1 = "cfgH1",
    cfgH2 = "cfgH2",
    cfgRFID = "cfgRFID",
    cfgOn = "cfgOn",
    cfgOzP1 = "cfgOzP1",
    cfgOzP2 = "cfgOzP2",
    cfgEx = "cfgEx",
    cfgPL = "cfgPL",
    cfgBS = "cfgBS",
    cfgSB = "cfgSB",
    cfgSP = "cfgSP",
    cfgFG = "cfgFG",
    cfgSDS = "cfgSDS",
    cfgYESS = "cfgYESS",
    cfgCTMode = "cfgCTMode",
    cfgpHoff = "cfgpHoff",
    cfgORPoff = "cfgORPoff",

    /* OLD PEAK VALUES */
    PeakNum = "PeakNum",
    PeakStart1 = "PeakStart1",
    PeakEnd1 = "PeakEnd1",
    PeakStart2 = "PeakStart2",
    PeakEnd2 = "PeakEnd2",
    MidPeakNum = "MidPeakNum",
    MidPeakStart1 = "MidPeakStart1",
    MidPeakEnd1 = "MidPeakEnd1",
    MidPeakStart2 = "MidPeakStart2",
    MidPeakEnd2 = "MidPeakEnd2",
    OffPeakStart = "OffPeakStart",
    OffPeakEnd = "OffPeakEnd",
    /* OLD PEAK VALUES */

    /* New Peak Management fields */
    Mode1 = "Mode1",
    EndMode1 = "EndMode1",
    Mode2 = "Mode2",
    EndMode2 = "EndMode2",
    Mode3 = "Mode3",
    EndMode3 = "EndMode3",
    Mode4 = "Mode4",
    EndMode4 = "EndMode4",
    Mode5 = "Mode5",
    EndMode5 = "EndMode5",
    Mode6 = "Mode6",
    EndMode6 = "EndMode6",
    /* New Peak Management fields */

    PeakHeater = "PeakHeater",
    PeakFilter = "PeakFilter",
    PeakOzone = "PeakOzone",
    MidPeakHeater = "MidPeakHeater",
    MidPeakFilter = "MidPeakFilter",
    MidPeakOzone = "MidPeakOzone",
    Sat = "Sat",
    Sun = "Sun",
    Mon = "Mon",
    Tue = "Tue",
    Wed = "Wed",
    Thu = "Thu",
    Fri = "Fri",

    sbpHind = "sbpHind",
    sbORPind = "sbORPind",
    SBORPhi = "SBORPhi",
    SBORPlo = "SBORPlo",
    /*
    * these 2 values are used to set the actual required value of the chlorine:
    *     Ex: I want the value to be 550: set SBORPhi: 555 and SBORPlo: 545.
    *     Ex: I want the value to be 650: set SBORPhi: 655 and SBORPlo: 645.
    *     Ex: I want the value to be 750: set SBORPhi: 755 and SBORPlo: 745.
    *
    * */
    SBpHhi = "SBpHhi",
    SBpHlo = "SBpHlo",


    /*
    * Network data
    * */
    interface="interface",

    Public_IP="Public_IP",
    Private_IP="Private_IP",
    MAC_Address="MAC_Address",

    SSID="SSID",
    Signal_Strength="Signal_Strength",
    Connection_Type="Connection_Type",

    stats_rx_packets="stats_rx_packets",
    stats_tx_packets="stats_tx_packets",

    stats_rx_errors="stats_rx_errors",
    stats_tx_errors="stats_tx_errors",

    stats_rx_dropped="stats_rx_dropped",
    stats_tx_dropped="stats_tx_dropped",

    stats_rx_bytes="stats_rx_bytes",
    stats_tx_bytes="stats_tx_bytes",

    /* RDT Lights */
    RDT_red = "RDT_red",
    RDT_green = "RDT_green",
    RDT_blue = "RDT_blue",
    RDT_bright = "RDT_bright",
    RDT_pattern = "RDT_pattern",

}